export default __webpack_public_path__ + "static/media/hamburger-menu.442778fb.svg";